import "./footer.scss";
import GetYear from "./GetYear";

function Footer() {
    function openList( btn_footer, list_footer) {
        let  btn = document.querySelector(`#${btn_footer}`);
        let  list = document.querySelector(`#${list_footer}`);
        let active = document.querySelector('.active-footer'),
            title_active = document.querySelector('.title-active-footer');
        if (active && (active !== list)) {
            active.classList.remove('active-footer')
        }
        if (title_active && (title_active !== btn) ) {
            title_active.classList.remove('title-active-footer');
        }
        list.classList.toggle('active-footer');
        btn.classList.toggle('title-active-footer');        
    };
    return (
        <footer className="footer">
            <div className="wrapper">
                <div className="footer__blocks">
                    <div className="footer__block-hello">
                        <div className="footer__logo">
                            <a className="footer__logo-link link" href="https://www.pult.ru/">
                                <img className="footer__logo-img" src="/img/logo_pult.svg" alt="pult.ru" />
                            </a>
                        </div>
                        <div className="footer__call">
                            <p className="footer__call-text">Звонок по России бесплатный</p>
                            <a className="footer__tel link bold" href="tel:+78005555152" >8 (812) 213-44-37</a>
                        </div>
                    </div>
                    <ul className="footer__columns">
                        <li className="footer__column">
                            <p className="title" onClick={() => openList("title-one","list-one" )} id="title-one">каталог
                                <svg className="pic" width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L4 4L7 1" stroke="#888888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                            </p>
                            <ul className="footer__list" id="list-one">
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/main/akustika/">Акустика</a>
                                </li>
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/main/hi-fi/">Hi-Fi</a>
                                </li>
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/main/vinil/">Винил</a>
                                </li>
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/main/naushniki/">Наушники</a>
                                </li>
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/main/televizory/">Телевизоры</a>
                                </li>
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/main/proektory/">Проекторы</a>
                                </li>
                            </ul>
                        </li>
                        <li className="footer__column">
                            <p className="title" onClick={() => openList("title-two","list-two" )} id="title-two">PULT.RU
                                <svg className="pic" width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L4 4L7 1" stroke="#888888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                            </p>
                            <ul className="footer__list" id="list-two">
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/main/akustika">О компании</a>
                                </li>
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/contacts/">Контакты</a>
                                </li>
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/contacts/">Салоны</a>
                                </li>
                                <li className="footer__list-item">
                                    <a className="footer__link link" href="https://www.pult.ru/news/">Новости</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div className="footer__copyright">
                     <GetYear />
                </div>

            </div>
        </footer>

    )
}
export default Footer;